/* API copy: `text` with the `highlight` substring rendered in the gold
   gradient. Falls back to the plain sentence when the highlight is missing
   or does not occur in the text. */
export default function Copy({ text = '', highlight }) {
  const at = highlight ? text.indexOf(highlight) : -1;
  if (at < 0) return text;
  return (
    <>
      {text.slice(0, at)}
      <span className="bbd-grad-text">{highlight}</span>
      {text.slice(at + highlight.length)}
    </>
  );
}
